import { AxiosGlobal } from "../shared/axios";
import { AxiosPromise } from "axios";
import configs from "../../configs";
import {
    AssetModel,
    ReportBreakdown,
    ContractBillModel,
    ContractBillSearchParams,
    ContractBillSearchResponse,
    ContractBillUpdateModel
} from "../../interfaces/models";


export class BreakdownLiveApis extends AxiosGlobal {

    getBreakdownByAccountId(account: string, pageSize: number, pageNumber: number, sort: string): AxiosPromise<Array<any>> {
        return this.axios.get(`${configs.context}/Breakdown/accounts/${account}/breakdown?pageSize=${pageSize}&pageNumber=${pageNumber}&sort=${sort}`);
    }


    getInventoryItems(account: string): AxiosPromise<Array<any>> {
        return this.axios.get(`${configs.context}/Breakdown/accounts/${account}/breakdown`);
    }



    updateBreakdownTools(data: any): AxiosPromise<Array<any>> {
        return this.axios.put(`${configs.context}/Breakdown/tools`, data);
    }

    getSingleBreakdownByAccountId(account: string, breakdownId: string): AxiosPromise<Array<any>> {
        return this.axios.get(`${configs.context}/Breakdown/accounts/${account}/breakdown/${breakdownId}`);
    }

    getAssetToServiceByAssetId(assetId: any, pageSize: number, pageNumber: number, sort: string): AxiosPromise<any> {
        return this.axios.get(`${configs.context}/ServiceSchedule/asset/${assetId}/services?pageSize=${pageSize}&pageNumber=${pageNumber}&sort=${sort}`);
    }

    filterBreakdownByAccountId(breakdownData: any, pageSize: number, pageNumber: number, sort: string): AxiosPromise<any> {
        // `AssetId` is an array param — repeat the key once per id. Nothing is
        // appended when no assets are selected, so existing callers are unaffected.
        const assetIds: Array<string> = Array.isArray(breakdownData?.assetIds) ? breakdownData.assetIds : [];
        const assetIdQuery = assetIds
            .filter((id: string) => !!id)
            .map((id: string) => `&AssetId=${encodeURIComponent(id)}`)
            .join('');

        return this.axios.get(`${configs.context}/Breakdown/accounts/${breakdownData?.accountId}/breakdown/search?pageSize=${pageSize}&pageNumber=${pageNumber}&sort=${sort}&assignedTo=${breakdownData?.assignedTo}&status=${breakdownData?.status}&assetName=${breakdownData?.assetName}&category=${breakdownData?.category}&BreakdownCategory=${breakdownData?.breakdownCategory}&SearchQuery=${breakdownData?.searchQuery}&vendor=${breakdownData?.vendor}&fromDate=${breakdownData?.fromDate}&BreakDownType=${breakdownData?.BreakDownType}&ReportType=${breakdownData?.ReportType}&toDate=${breakdownData?.toDate}&filterType=${breakdownData?.filterType}&all=${breakdownData?.all ? breakdownData?.all : false}&IncludeChecklist=${breakdownData?.includeChecklist ? true : false}${assetIdQuery}`);
    }


    filterBreakdownByAssetId(breakdownData: any, pageSize: number, pageNumber: number, sort: string): AxiosPromise<any> {
        return this.axios.get(`${configs.context}/Breakdown/accounts/${breakdownData?.accountId}/breakdown/search?pageSize=${pageSize}&pageNumber=${pageNumber}&sort=${sort}&AssetId=${breakdownData?.assetId}`);
    }


    getBreakdownAggregateByAccountId(account: string): AxiosPromise<Array<any>> {
        return this.axios.get(`${configs.context}/breakdown-analytics/accounts/${account}`);
    }

    getBreakdownAnalyticsByAccountIdAndBreakdownType(account: string, breakdownType: string): AxiosPromise<Array<any>> {
        return this.axios.get(`${configs.context}/breakdown-analytics/accounts/${account}?breakdownType=${breakdownType}`);
    }

    getBreakdownStatByAccountId(account: string, year: string, month: string, catId: string): AxiosPromise<Array<any>> {
        return this.axios.get(`${configs.context}/breakdown-analytics/accounts/${account}/years/${year}/months/${month}?categoryId=${catId}`);
    }

    getCategoryHistoryByAccountId(account: string, year: string, month: string): AxiosPromise<Array<any>> {
        return this.axios.get(`${configs.context}/breakdown-analytics/accounts/${account}/years/${year}/months/${month}/category-history`);
    }


    // ==================== TOOLS APIs ====================

    getBreakdownTools(accountId: string, breakdownId: string): AxiosPromise<any> {
        return this.axios.get(`${configs.context}/BreakdownTools/breakdown/${breakdownId}`);
    }

    addBreakdownTools(data: any): AxiosPromise<any> {
        return this.axios.post(`${configs.context}/BreakdownTools`, data);
    }

    removeBreakdownTool(accountId: string, breakdownId: string, toolId: string): AxiosPromise<any> {
        return this.axios.delete(`${configs.context}/BreakdownTools/${toolId}`);
    }



    deleteBreakdownByAccountIdAndBreakdownId(breakdownId: string, accountId: string): AxiosPromise<Array<any>> {
        return this.axios.delete(`${configs.context}/Breakdown/accounts/${accountId}/breakdown/${breakdownId}`);
    }

    updateAssetByAccoutId(assetModel: AssetModel): AxiosPromise<AssetModel> {
        return this.axios.put(`${configs.context}/Breakdown/accounts/${assetModel?.accountId}/asset`, assetModel);
    }

    assignBreakdownToUser(breakdownModel: any): AxiosPromise<any> {
        return this.axios.put(`${configs.context}/Breakdown/accounts/${breakdownModel?.accountId}/breakdown/assign`, breakdownModel);
    }

    assignUserToSchedule(data: any): AxiosPromise<any> {
        return this.axios.put(`${configs.context}/ServiceSchedule/${data?.scheduleId}/handlers/${data?.handlerId}/assign`);
    }

    addResolution(relsolution: any, accountId: string): AxiosPromise<any> {
        return this.axios.put(`${configs.context}/Breakdown/accounts/${accountId}/breakdown/resolution`, relsolution);
    }

    updateResponseTime(response: any, accountId: string): AxiosPromise<any> {
        return this.axios.put(`${configs.context}/Breakdown/accounts/${accountId}/breakdown/response-time?BreakdownId=${response?.breakdownId}&ResponseTime=${response?.responseTime}`, response);
    }

    updateResolveTime(response: any, accountId: string): AxiosPromise<any> {
        return this.axios.put(`${configs.context}/Breakdown/accounts/${accountId}/breakdown/resolve-time?BreakdownId=${response?.breakdownId}&ResolutionTime=${response?.resolveTime}`, response);
    }


    updateCost(response: any, accountId: string): AxiosPromise<any> {
        return this.axios.put(`${configs.context}/Breakdown/accounts/${accountId}/breakdown/resolution/cost`, response);
    }

    addChecklist(checklist: any, id: string): AxiosPromise<any> {
        return this.axios.put(`${configs.context}/ServiceSchedule/${id}/asset`, checklist);
    }

    deleteBreakdownActivity(activitiyId: string, accountId: string): AxiosPromise<Array<any>> {
        return this.axios.delete(`${configs.context}/accounts/${accountId}/breakdown/activities/${activitiyId}`);
    }


    scheduleService(data: any): AxiosPromise<any> {
        return this.axios.post(`${configs.context}/servicing`, data);
    }

    updateScheduleService(data: any): AxiosPromise<any> {
        return this.axios.put(`${configs.context}/servicing`, data);
    }

    getSingleServiceContract(id: string): AxiosPromise<Array<any>> {
        return this.axios.get(`${configs.context}/servicing/${id}`);
    }

    /** Bills raised against a contract (requires billing tracking enabled). Paged. */
    searchContractBills(params: ContractBillSearchParams): AxiosPromise<ContractBillSearchResponse> {
        // Omit blank params entirely — the API treats an empty `Status=` as a filter
        // for the empty string rather than "no filter".
        const query: string = Object.entries(params)
            .filter(([, value]) => value !== undefined && value !== null && value !== '')
            .map(([key, value]) => `${key}=${encodeURIComponent(String(value))}`)
            .join('&');

        return this.axios.get(`${configs.context}/servicing/contract-bills/search?${query}`);
    }

    getContractBill(billId: string): AxiosPromise<ContractBillModel> {
        return this.axios.get(`${configs.context}/servicing/contract-bills/${billId}`);
    }

    /** Amount / description / status only — `billingDate` is server-owned. */
    updateContractBill(data: ContractBillUpdateModel): AxiosPromise<ContractBillModel> {
        return this.axios.put(`${configs.context}/servicing/contract-bills`, data);
    }

    /** Multipart: the receipt is a file upload, and is optional. */
    markContractBillAsPaid(billId: string, referenceNumber: string, receipt?: File): AxiosPromise<ContractBillModel> {
        const formData = new FormData();
        formData.append('Id', billId);
        formData.append('ReferenceNumber', referenceNumber || '');
        if (receipt) formData.append('Receipt', receipt);

        return this.axios.put(`${configs.context}/servicing/contract-bills/mark-as-paid`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }

    deleteContractBill(billId: string): AxiosPromise<any> {
        return this.axios.delete(`${configs.context}/servicing/contract-bills/${billId}`);
    }


    createCategory(data: any): AxiosPromise<any> {
        return this.axios.post(`${configs.context}/Breakdown/accounts/${data?.accountId}/breakdowncategory`, data);
    }

    getCategory(accountId: any): AxiosPromise<any> {
        return this.axios.get(`${configs.context}/Breakdown/accounts/${accountId}/breakdowncategory`);
    }

    getServiceAggregate(accountId: any): AxiosPromise<any> {
        return this.axios.get(`${configs.context}/ServiceSchedule/accounts/${accountId}/aggregate`);
    }

    viewedBreakdownActivities(accountId: any, breakdownId: any): AxiosPromise<any> {
        return this.axios.put(`${configs.context}/accounts/${accountId}/breakdown/${breakdownId}/viewed`);
    }

    searchServiceData(serviceData: any, pageSize: number, pageNumber: number, sort: string): AxiosPromise<any> {
        return this.axios.get(`${configs.context}/ServiceSchedule/search?pageSize=${pageSize}&pageNumber=${pageNumber}&sort=${sort}&SearchQuery=${serviceData?.SearchQuery}&Status=${serviceData?.Status}&FromDate=${serviceData?.FromDate}&ToDate=${serviceData?.ToDate}&AssetId=${serviceData?.AssetId}&ContractId=${serviceData?.ContractId}&AccountId=${serviceData?.AccountId}`);
    }

    getServiceSchedules(accountId: any): AxiosPromise<any> {
        return this.axios.get(`${configs.context}/ServiceSchedule/accounts/${accountId}`);
    }

    updateCategory(data: any): AxiosPromise<any> {
        return this.axios.put(`${configs.context}/Breakdown/accounts/${data?.accountId}/breakdown/category`, data);
    }

    startService(serviceId: any): AxiosPromise<any> {
        return this.axios.put(`${configs.context}/ServiceSchedule/${serviceId}/start`, serviceId);
    }

    getApproval(data: any, id: any): AxiosPromise<any> {
        return this.axios.put(`${configs.context}/ServiceSchedule/${id}/SetApproval-Schedule`, data);
    }

    getApprovalForScheduleAsset(data: any, id: any): AxiosPromise<any> {
        return this.axios.put(`${configs.context}/ServiceSchedule/asset/${id}/SetApproval-ScheduledAsset`, data);
    }

    getApprovalRemark(data: any, id: any): AxiosPromise<any> {
        return this.axios.put(`${configs.context}/ServiceSchedule/${id}/approval-remarks`, data);
    }

    completeService(serviceId: any, data: any): AxiosPromise<any> {
        return this.axios.put(`${configs.context}/ServiceSchedule/${serviceId}/complete`, data);
    }
    completeAssetService(serviceId: any, assetId: any): AxiosPromise<any> {
        return this.axios.put(`${configs.context}/ServiceSchedule/${serviceId}/asset/${assetId}/complete`);
    }


    completeScheduleAssetService(serviceId: any, data: any): AxiosPromise<any> {
        return this.axios.put(`${configs.context}/ServiceSchedule/asset/${serviceId}/complete`, data);
    }


    addScheduleChecklist(data: any): AxiosPromise<any> {
        return this.axios.post(`${configs.context}/ServiceSchedule/checklists`, data);
    }

    missedReason(serviceId: any, data: any): AxiosPromise<any> {
        return this.axios.put(`${configs.context}/ServiceSchedule/${serviceId}/missed-reason`, data);
    }

    deleteSchedule(serviceId: any): AxiosPromise<any> {
        return this.axios.delete(`${configs.context}/ServiceSchedule/${serviceId}`);
    }

    deleteContract(serviceId: any): AxiosPromise<any> {
        return this.axios.delete(`${configs.context}/servicing/${serviceId}`);
    }


    getServiceDetails(id: any): AxiosPromise<any> {
        return this.axios.get(`${configs.context}/ServiceSchedule/${id}`);
    }


    getScheduleChecklist(id: any): AxiosPromise<any> {
        return this.axios.get(`${configs.context}/ServiceSchedule/checklists/${id}`);
    }

    updateChecklistData(data: any): AxiosPromise<any> {
        return this.axios.put(`${configs.context}/ServiceSchedule/checklists/${data?.id}`, data);
    }

    deleteChecklist(serviceId: any): AxiosPromise<any> {
        return this.axios.delete(`${configs.context}/ServiceSchedule/checklists/${serviceId}`);
    }


    getServiceContractById(id: any): AxiosPromise<any> {
        return this.axios.get(`${configs.context}/servicing/${id}`);
    }

    updateServiceContractStatus(data: any): AxiosPromise<any> {
        return this.axios.put(`${configs.context}/servicing/${data?.id}/status/${data?.status}`, data);
    }

    getExternalApprovalUrl(scheduleId: string): AxiosPromise<any> {
        return this.axios.get(`${configs.context}/ServiceSchedule/${scheduleId}/external-approval-url`);
    }

    getPublicSchedule(scheduleId: string, expiry: string, token: string): AxiosPromise<any> {
        return this.axios.get(`${configs.context}/Public/schedule/${scheduleId}?expiry=${encodeURIComponent(expiry)}&token=${encodeURIComponent(token)}`);
    }

    approvePublicSchedule(scheduleId: string, expiry: string, token: string, data: FormData): AxiosPromise<any> {
        return this.axios.post(`${configs.context}/Public/schedule/${scheduleId}/approve?expiry=${encodeURIComponent(expiry)}&token=${encodeURIComponent(token)}`, data, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    }

    getExternalApprovalUrlForAsset(assetId: string): AxiosPromise<any> {
        return this.axios.get(`${configs.context}/ServiceSchedule/asset/${assetId}/external-approval-url`);
    }

    getPublicScheduleAsset(scheduleAssetId: string, expiry: string, token: string): AxiosPromise<any> {
        return this.axios.get(`${configs.context}/Public/schedule_asset/${scheduleAssetId}?expiry=${encodeURIComponent(expiry)}&token=${encodeURIComponent(token)}`);
    }

    approvePublicScheduleAsset(id: string, expiry: string, token: string, data: FormData): AxiosPromise<any> {
        return this.axios.post(`${configs.context}/Public/schedule_asset/${id}/approve?expiry=${encodeURIComponent(expiry)}&token=${encodeURIComponent(token)}`, data, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    }

    // To Change the status of the Asset Schedule
    updateScheduleAssetStatus(scheduleId: string, assetData: any): AxiosPromise<any> {
        return this.axios.put(`${configs.context}/ServiceSchedule/${scheduleId}/asset`, assetData);
    }


    createBreakdownActivity(data: any, accountId: any): AxiosPromise<any> {
        return this.axios.post(`${configs.context}/accounts/${accountId}/breakdowns/activities`, data);
    }

    filterServiceByAccountId(contractData: any, pageSize: number, pageNumber: number, sort: string): AxiosPromise<any> {
        // /servicing/search takes every filter on the query string. `contractData`
        // used to be passed as the axios *config* argument, which silently threw
        // Status/ContractorType/query/AssetId away. Only non-empty filters are
        // appended — the endpoint's enum params will not bind an empty string.
        const params = new URLSearchParams({
            pageSize: String(pageSize),
            pageNumber: String(pageNumber),
            // The API enum is Ascending/Descending.
            sort: sort ? sort.charAt(0).toUpperCase() + sort.slice(1) : 'Ascending',
            AccountId: contractData?.AccountId ?? '',
        });

        (['Status', 'ContractorType', 'query', 'AssetId'] as const).forEach((key) => {
            if (contractData?.[key]) params.append(key, contractData[key]);
        });

        return this.axios.get(`${configs.context}/servicing/search?${params.toString()}`);
    }

    getBreakdownActivities(breakdownData: any, pageSize: number, pageNumber: number, sort: string): AxiosPromise<any> {
        return this.axios.get(`${configs.context}/accounts/${breakdownData?.accountId}/breakdown/${breakdownData?.breakdownId}/activities?pageSize=${pageSize}&pageNumber=${pageNumber}&sort=${sort}&accountId=${breakdownData?.accountId}`, breakdownData);
    }



    reportBreakdown(breakdown: ReportBreakdown, accountId: any): AxiosPromise<ReportBreakdown> {
        return this.axios.post(`${configs.context}/Breakdown/accounts/${accountId}/breakdown`, breakdown);
    }


    reportPublicBreakdown(breakdown: any): AxiosPromise<ReportBreakdown> {
        return this.axios.post(`${configs.context}/Public/breakdowns/report`, breakdown);
    }
    createWorkOrder(orderData: any): AxiosPromise<ReportBreakdown> {
        return this.axios.post(`${configs.context}/Breakdown/accounts/work-order`, orderData);
    }

    updateWorkOrder(data: any): AxiosPromise<any> {
        return this.axios.put(`${configs.context}/Breakdown/accounts/work-order`, data);
    }

    updateProgressPercentage(data: any): AxiosPromise<any> {
        return this.axios.put(`${configs.context}/Breakdown/accounts/work-orders/progress`, data);
    }

    requestReview(workId: string, reviewerId: string): AxiosPromise<any> {
        return this.axios.put(`${configs.context}/Breakdown/accounts/work/${workId}/request-review/${reviewerId}`, {
            workId,
            reviewerId
        });
    }

    respondToReview(data: any): AxiosPromise<any> {
        return this.axios.put(`${configs.context}/Breakdown/accounts/work/review/respond`, data);
    }

    // Report Schedule

    createReportSchedule(data: any): AxiosPromise<any> {
        return this.axios.post(`${configs.context}/ReportSchedule`, data);
    }

    searchReportSchedule(searchData: any, pageSize: number, pageNumber: number, sort: string): AxiosPromise<any> {
        return this.axios.get(`${configs.context}/ReportSchedule/search?Query=${searchData?.query}&FromDate=${searchData?.fromDate}&ToDate=${searchData?.toDate}&ReportType=${searchData?.reportType}&IsRecurring=${searchData?.isRecurring}&Status=${searchData?.status}&PageSize=${pageSize}&PageNumber=${pageNumber}&Sort=${sort}&All=${searchData?.all || false}`);
    }

    getReportScheduleByReportId(reportId: string): AxiosPromise<Array<any>> {
        return this.axios.get(`${configs.context}/ReportSchedule/${reportId}`);
    }

    deleteReportSchedule(reportId: string): AxiosPromise<Array<any>> {
        return this.axios.delete(`${configs.context}/ReportSchedule/${reportId}`);
    }

    updateReportSchedule(data: any): AxiosPromise<any> {
        return this.axios.put(`${configs.context}/ReportSchedule`, data);
    }

    updateReportScheduleStatus(scheduleId: string, status: string): AxiosPromise<any> {
        return this.axios.put(`${configs.context}/ReportSchedule/${scheduleId}/status/${status}`);
    }

    searchReportFiles(searchData: any, pageSize: number, pageNumber: number, sort: string): AxiosPromise<any> {
        return this.axios.get(`${configs.context}/ReportFiles/search?Query=${searchData?.query || ''}&FromDate=${searchData?.fromDate || ''}&ToDate=${searchData?.toDate || ''}&ReportType=${searchData?.reportType || ''}&ScheduleId=${searchData?.scheduleId || ''}&ItemGroupId=${searchData?.itemGroupId || ''}&PageSize=${pageSize}&PageNumber=${pageNumber}&Sort=${sort}&All=${searchData?.all || false}`);
    }

    deleteReportFile(id: string): AxiosPromise<any> {
        return this.axios.delete(`${configs.context}/ReportFiles/${id}`);
    }

    downloadReportFile(filePath: string): AxiosPromise<Blob> {
        return this.axios.get(filePath, {
            responseType: 'blob',
        });
    }



    updateBreakdownStatus(data: any): AxiosPromise<any> {
        return this.axios.put(`${configs.context}/Breakdown/accounts/${data.accountId}/breakdown/status`, data);
    }


    // ==================== CHECKLIST APIs ====================

    getWorkOrderChecklists(accountId: string, workOrderId: string): AxiosPromise<any> {
        return this.axios.get(`${configs.context}/BreakdownChecklist/breakdown/${workOrderId}`);
    }

    createWorkOrderChecklist(data: any): AxiosPromise<any> {
        return this.axios.post(`${configs.context}/BreakdownChecklist`, data);
    }

    updateWorkOrderChecklist(data: any): AxiosPromise<any> {
        return this.axios.put(`${configs.context}/BreakdownChecklist`, data);
    }

    toggleWorkOrderChecklist(data: any): AxiosPromise<any> {
        return this.axios.patch(`${configs.context}/BreakdownChecklist/accounts/${data.accountId}/work-order/${data.workOrderId}/checklists/${data.checklistId}/toggle`, data);
    }

    deleteWorkOrderChecklist(accountId: string, workOrderId: string, checklistId: string): AxiosPromise<any> {
        return this.axios.delete(`${configs.context}/BreakdownChecklist/${checklistId}`);
    }

    /**
     * Persists a whole checklist order in one call. The body is just the checklist
     * ids in the order they should appear — the server derives each item's `index`
     * from its position in the array.
     */
    reorderWorkOrderChecklists(checklistIds: Array<string>): AxiosPromise<any> {
        return this.axios.put(`${configs.context}/BreakdownChecklist/reorder`, checklistIds);
    }

    // ==================== PURCHASED ITEMS APIs ====================

    searchBreakdownParts(
        pageSize: number,
        pageNumber: number,
        sort: string = 'Descending',
        queryString?: string,
        status?: string,
        actionType?: string,
        // itemGroup?: string,
        all: boolean = false
    ): AxiosPromise<any> {
        const params = new URLSearchParams({
            PageSize: pageSize.toString(),
            PageNumber: pageNumber.toString(),
            Sort: sort,
            All: all.toString()
        });

        if (queryString && queryString.trim() !== '') {
            params.append('QueryString', queryString);
        }
        if (status && status.trim() !== '') {
            params.append('Status', status);
        }
        if (actionType && actionType.trim() !== '') {
            params.append('ActionType', actionType);
        }
        // if (itemGroup && itemGroup.trim() !== '') {
        //     params.append('ItemGroup', itemGroup);
        // }

        return this.axios.get(`${configs.context}/BreakdownParts/search?${params.toString()}`);
    }

    getWorkOrderPurchasedItems(accountId: string, workOrderId: string): AxiosPromise<any> {
        return this.axios.get(`${configs.context}/BreakdownParts/breakdown/${workOrderId}`);
    }

    createWorkOrderPurchasedItem(data: any): AxiosPromise<any> {
        return this.axios.post(`${configs.context}/BreakdownParts`, data);
    }

    updateWorkOrderPurchasedItem(data: any): AxiosPromise<any> {
        return this.axios.put(`${configs.context}/BreakdownParts`, data);
    }

    deleteWorkOrderPurchasedItem(accountId: string, workOrderId: string, itemId: string): AxiosPromise<any> {
        return this.axios.delete(`${configs.context}/BreakdownParts/${itemId}`);
    }

    deleteBreakdownPart(itemId: string): AxiosPromise<any> {
        return this.axios.delete(`${configs.context}/BreakdownParts/${itemId}`);
    }

    completePartReturn(formData: FormData): AxiosPromise<any> {
        return this.axios.put(`${configs.context}/BreakdownParts/returned`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }


} 